/** @module api/remote */

import { apiCall } from '@/api/index'
import { apiV1AmperixPath, apiV1AmperixesPath, apiV1EnergyManagersExistPath } from '@/../lib/routes'

export function getAmperixes({ ctxt }) {
  return apiCall({
    path: apiV1AmperixesPath(ctxt)
  })
}

export function getAmperix({ ctxt, serialNumber }) {
  return apiCall({
    path: apiV1AmperixPath(ctxt, serialNumber)
  })
}

export function getEnergyManagerExists({ serialno }) {
  return apiCall({
    path: apiV1EnergyManagersExistPath(serialno)
  })
}
